import PartySec from "./PartySec";

export default PartySec;
